module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "margin-b10"
  }, [_c('div', {
    staticClass: "plain-box"
  }, [_c('div', [(_vm.type != 'newContract' && !_vm.rodosol) ? _c('div', {
    staticClass: "col-md small-padding-left"
  }, [_c('div', {
    staticClass: "fourth-col"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.window.open(_vm.urlMoveCargo, '_blank')
      }
    }
  }, [_vm._v("\n                Ative sua TAG\n              ")])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-line"
  }, [_c('h3', {
    staticClass: "sub-title plan upper"
  }, [_vm._v("Tag Move Cargo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }), _vm._v(" "), _c('p', [_vm._v("\n                O Vale-Pedágio Obrigatório (VPO) é um direito assegurado pela Lei nº 10.209/2001 e regulamentado pela Resolução ANTT nº 6.024/2023. Ele deve ser pago, por viagem, aos transportadores — sejam pessoas físicas ou jurídicas — responsáveis pelo transporte rodoviário de cargas.\n              ")]), _vm._v(" "), _c('p', [_vm._v("  \n                Importante destacar que o valor do pedágio não pode ser incluído no frete. Caso isso ocorra, o embarcador estará sujeito à aplicação de multa, conforme previsto na legislação.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-line"
  }, [_c('h3', [_vm._v("Sem mensalidade e sem taxa de adesão")]), _vm._v(" "), _c('p', [_vm._v("\n                Use quando precisar, sem custos fixos ou surpresas.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fourty-line"
  }, [_c('h3', [_vm._v("Pagamento automático pela tag")]), _vm._v(" "), _c('p', [_vm._v("\n                Funciona conforme as normas de regulamentação, garantindo praticidade e segurança nas passagens.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fifty-line"
  }, [_c('h3', [_vm._v("Pensado para o dia a dia dos transportadores")]), _vm._v(" "), _c('p', [_vm._v("\n                Solução sob medida para quem vive na estrada e precisa de agilidade para receber Vale-pedágio.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixty-line"
  }, [_c('h3', [_vm._v("Atendimento exclusivo e dedicado")]), _vm._v(" "), _c('p', [_vm._v("\n                Conte com uma equipe especializada para te atender sempre que precisar.\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-637811f5!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plans/vpo.vue
// module id = 2151
// module chunks = 1